import {Component, OnInit, ChangeDetectorRef} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {ApiService} from '../../../services/api.service';
import {ErrorService} from '../../../shared/error-page/service/error-service';
import {TransactionWrapper} from '../../../model/transactionWrapper';
import {PostPurchaseWrapper} from '../../../model/postPurchaseWrapper';
import {ActivatedRoute, Router} from '@angular/router';
import {Constants} from '../../../constants/ebtq-constants';
import {UntypedFormControl, UntypedFormGroup} from '@angular/forms';
import {SearchUpdateModelVO} from '../../../model/searchUpdateModelVO';
import {Title} from '@angular/platform-browser';


@Component({
  standalone: false,
  selector: 'app-post-purchase-adjustments',
  templateUrl: './post-purchase-adjustments.component.html',
  styleUrls: ['./post-purchase-adjustments.component.scss']
})
export class PostPurchaseAdjustmentsComponent implements OnInit {
  lnNumber = '';
  containsError = false;
  errorMsg: string;
  postPurchaseWrap: PostPurchaseWrapper;
  updatedLoan: string;
  successMess: string;
  successBlock = false;
  errHeading: string;
  errors: any[];
  searchModel: SearchUpdateModelVO;
  searchForm = new UntypedFormGroup({
    lnNumber: new UntypedFormControl('')
  });
  title = 'Post Purchase Adjustments';

  constructor(private routers: ActivatedRoute, private httpService: HttpClient, private apiService: ApiService,
              private router: Router, private errorService: ErrorService, private titleService: Title,
              private cdr: ChangeDetectorRef) {
  }

  ngOnInit(): void {
    this.titleService.setTitle(this.title);
    this.errHeading = Constants.ERROR_HEADER;
    this.routers.queryParams.subscribe(params => {
      if (params.query !== undefined) {
        this.updatedLoan = JSON.parse(atob(params.query));
        if (this.updatedLoan != null && this.updatedLoan !== '') {
          this.successBlock = true;
          this.successMess = Constants.UPDATE_PPA_SUCC_MESS.replace('{0}', this.updatedLoan);
        }
      }
      this.cdr.detectChanges();
    });
  }

  validateInput() {
    let valid = true;

    if (this.lnNumber === undefined || this.lnNumber === '')
    {
      this.errors.push(Constants.FAN_LN_NULL);
      valid = false;
    }

    else if (this.lnNumber.length < 10)
    {
      this.errors.push(Constants.PPA_LN_NUM_COU);
      valid = false;
    }

    else if (this.lnNumber[0] !== '6' && this.lnNumber.length === 10)
    {
      this.errors.push(Constants.FAN_LN_INVLID.replace('{0}', this.lnNumber));
      valid = false;
    }

    return valid;
  }

  retrieveLoanDetails() {
    const transactionWrapper = new TransactionWrapper();
    transactionWrapper.parameters[0] = this.searchForm.value.lnNumber;
    transactionWrapper.queryServiceName = Constants.QUERY_LOAN_DETAILS;
    this.apiService.retrieveLoanDetails(transactionWrapper)
      .subscribe(
        (data: any) => {
          this.postPurchaseWrap = data;
          /** Routing to result page when there are matching records. passing list of matching keys to get results */
          this.router.navigate(['postPurchaseUpdate'], {
            queryParams: {query: btoa(JSON.stringify(this.postPurchaseWrap))}
          });
        },
        error => {
          this.errorService.announceError(error);
        });
    this.errorAnnouncement();
  }

  errorAnnouncement() {
    // error announcement
    this.errorService.errorAnnouncedSource$.subscribe(
      message => {
        this.errorMsg = message;
        this.containsError = true;
        this.cdr.detectChanges();
      }
    );
  }

  submit() {
    this.successMess = '';
    this.successBlock = false;
    this.lnNumber = this.searchForm.value.lnNumber;
    this.errors = [];

    if (this.validateInput())
    {
      // Check if the loan is an active loan
      const tempTransactionWrp = new TransactionWrapper();
      tempTransactionWrp.queryServiceName = Constants.QUERY_SERV_NAME;
      tempTransactionWrp.parameters[0] = this.lnNumber;

      this.apiService.executeQuery(tempTransactionWrp).subscribe(
        (data: any) => {

          // Check if an invalid loan number that starts with 6 returns an empty object
          if (data.object.length === 0)
          {
            this.errors.push(Constants.FAN_LN_INVLID.replace('{0}', this.lnNumber));
          }

          // Check if the valid loan is not an active loan
          if (data.object[0].LN_ACTV_STAT_CD !== 0)
          {
            this.errors.push(Constants.LOAN_NOT_ACTIV);
          }

          // Loan is an active loan
          else
          {
            this.retrieveLoanDetails();
          }
          this.cdr.detectChanges();
        },
        error => {
          this.errorService.announceError(error);
        }
      );
      this.errorAnnouncement();
    }
  }

  numberOnly(event): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;

  }
}
